import { apiV2Root } from "consts";
import { useDataQueryParams } from "hooks/useDataQueryParams";

import { PAGES_QUERY_KEY, type Page } from "./types";

export const usePages = (): Page[] | undefined =>
  useDataQueryParams<Page[]>(PAGES_QUERY_KEY, {}, apiV2Root);
